import createComponent from '@carvana/merch-components/createComponent';

export const GoldText = createComponent('span', {
  className: 'text-brand-tertiary'
});

export const Heading = createComponent('h1', {
  className: 't-heading-2xl text-text-inverse md:t-heading-3xl'
});

export const HeroWrapper = createComponent('section', {
  className:
    'relative h-[300px] overflow-hidden bg-background-strong md:h-[250px]'
});

export const Subtitle = createComponent('p', {
  className:
    't-body-sm text-text-inverse max-w-[75%] md:t-body-lg md:max-w-[45%]'
});

export const TextContent = createComponent('div', {
  className:
    'relative z-10 flex flex-col gap-lg px-2xl pt-3xl pb-2xl md:h-full md:justify-center md:py-4xl md:pl-[84px] md:pr-0'
});
